import Box from '@mui/material/Box'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import { Link as RouterLink, useSearchParams } from 'react-router-dom'

import { paths } from '@/paths'

export const HEALTH_TABS = [
	{ key: 'overview', label: 'Overview' },
	{ key: 'notifications', label: 'Notifications' },
] as const

export type HealthTabKey = (typeof HEALTH_TABS)[number]['key']

export function isHealthTabKey(value: string | null): value is HealthTabKey {
	return HEALTH_TABS.some((tab) => tab.key === value)
}

export function healthTabHref(tab: HealthTabKey): string {
	if (tab === 'overview') {
		return paths.dashboard.health
	}
	return `${paths.dashboard.health}?tab=${tab}`
}

export function HealthTabs() {
	const [searchParams] = useSearchParams()
	const tabParam = searchParams.get('tab')
	const current = isHealthTabKey(tabParam) ? tabParam : 'overview'

	return (
		<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
			<Tabs data-test="health-tabs" value={current} variant="scrollable">
				{HEALTH_TABS.map((tab) => (
					<Tab component={RouterLink} key={tab.key} label={tab.label} to={healthTabHref(tab.key)} value={tab.key} />
				))}
			</Tabs>
		</Box>
	)
}
